import React, {useEffect, useState} from "react";
import styles from "./chart/Chart.module.scss";
import moment from "moment";

const Chart = ({ title, mainLayerValue, mainLayerLabel, comparisonLayerValue, comparisonLayerLabel, comparisonLayerColor, type = 'int', scale }) => {

    const [range, setRange] = useState(null)

    const handleLabelTemplate = (timeData, color) => {
        const mainLabelColorStyle = {color};
        const date = moment.duration(timeData, "seconds");
        const years = date.years();
        const months = date.months();
        const days = date.days();
        const hours = date.hours();
        const minutes = date.minutes();
        const seconds = date.seconds();
        const milliseconds = Math.floor(date.milliseconds());

        return  <div className={styles.label}>
            <span>{ years !==0 && <><span>{years}</span><span> Y </span></> }</span>
            <span>{ months !==0 && <><span>{months}</span><span> M </span></> }</span>
            <span>{ days !==0 && <><span>{days}</span><span> D </span></> }</span>
            <span>{ hours !==0 && <><span>{hours}</span><span> H </span></> }</span>
            <span>{ minutes !==0 && <><span>{minutes}</span><span> m </span></> }</span>
            <span>{ seconds !==0 && <><span>{seconds}</span><span> s </span></> }</span>
            {
                years === 0 && months === 0 && days === 0 && hours === 0 && minutes === 0 && seconds === 0 &&
                    <span>{ milliseconds !==0 && <><span style={mainLabelColorStyle}>{milliseconds}</span><span> ms</span></> }</span>
            }
        </div>
    }

    useEffect(() => {
        const maxTimeData = Math.max(mainLayerValue, comparisonLayerValue)
        const minTimeData = Math.min(mainLayerValue, comparisonLayerValue)
        const maxDate = moment.duration(maxTimeData, "seconds");
        const minDate = moment.duration(minTimeData, "seconds");

        let r = null

        if (type === "time") {
            const maxYears = maxDate.years();
            const maxMonths = maxDate.months();
            const maxDays = maxDate.days();
            const maxHours = maxDate.hours();
            const maxMinutes = maxDate.minutes();

            const minYears = minDate.years();
            const minMonths = minDate.months();
            const minDays = minDate.days();
            const minHours = minDate.hours();
            const minMinutes = minDate.minutes();

            const isYearsDifferentNotEqual = maxYears !== minYears
            const isMonthsDifferentNotEqual = maxMonths !== minMonths
            const isDaysDifferentNotEqual = maxDays !== minDays
            const isHoursDifferentNotEqual = maxHours !== minHours
            const isMinutesDifferentNotEqual = maxMinutes !== minMinutes


            if (isYearsDifferentNotEqual) {
                r = {value: maxYears, title: "Years"}
            } else if (isMonthsDifferentNotEqual) {
                r = {value: maxMonths, title: "Months"}
            } else if (isDaysDifferentNotEqual) {
                r = {value: maxDays, title: "Days"}
            } else if (isHoursDifferentNotEqual) {
                r = {value: maxHours, title: "Hours"}
            } else if (isMinutesDifferentNotEqual) {
                r = {value: maxMinutes < 20 ? maxMinutes : '', title: "Hours"}
            }
        }

        setRange(r)
    }, [])

    const handleShowLabel = (layerType) => {
        if (layerType === "mainLayer") {
            if (type === "time") {
                return handleLabelTemplate(mainLayerValue, "#8A0FFF");
            } else {
                return <div>{ mainLayerLabel }</div>
            }
        } else if (layerType === "comparisonLayer") {
            if (type === "time") {
                return handleLabelTemplate(comparisonLayerValue, comparisonLayerColor);
            } else {
                return <div>{ comparisonLayerLabel }</div>
            }
        } else {
            const maxNum = Math.max(mainLayerValue, comparisonLayerValue);
            const minNum = Math.min(mainLayerValue, comparisonLayerValue);
            const diffs = maxNum - minNum;
            if (type === "time") {
                return handleLabelTemplate(diffs, "#0A195C");
            } else {
                return <div>{ diffs }</div>
            }
        }
    }

    let mainLayerScale = parseInt(Math.floor((100 / Math.max(mainLayerValue, comparisonLayerValue)) * mainLayerValue)) || 0;
    let comparisonLayerScale = parseInt(Math.floor((100 / Math.max(mainLayerValue, comparisonLayerValue)) * comparisonLayerValue)) || 0;

    return (
        <div className={styles.Chart}>
            <div className={`${styles.barsChart}`}>
                <div className={styles.bar}>
                    <div style={{left: `calc(${parseInt(mainLayerScale) || 0}% + 8px)`, width: `calc(${parseInt(Math.floor((Math.max(mainLayerScale, comparisonLayerScale)) - mainLayerScale)) || 0}% - 8px)`}} className={styles.emptyBar}>
                        <div className={styles.info}>
                            <div>{ handleShowLabel("info") }</div>
                        </div>
                    </div>
                    <div style={{width: `${mainLayerScale}%`}} className={styles.progress}>
                        <div className={styles.info}>
                            <div>{ handleShowLabel("mainLayer") }</div>
                        </div>
                    </div>
                </div>
                <div className={styles.bar}>
                    <div style={{left: `calc(${parseInt(comparisonLayerScale) || 0}% + 8px)`, width: `calc(${parseInt(Math.floor((Math.max(mainLayerScale, comparisonLayerScale)) - comparisonLayerScale)) || 0}% - 8px)`}} className={styles.emptyBar}>
                        <div className={styles.info}>
                            <div>{ handleShowLabel("info") }</div>
                        </div>
                    </div>
                    <div style={{backgroundColor: comparisonLayerColor, width: `${comparisonLayerScale}%`}} className={styles.progress}>
                        <div className={styles.info}>
                            <div>{ handleShowLabel("comparisonLayer") }</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.rangeViewer}>
                <ul>
                    {
                        Array.from({length: range ? range.value + 1 : 8})
                          .map((_, index) => (
                              range && <li key={index}>
                                  {index}
                              </li>
                            )
                          )
                    }
                </ul>
            </div>
            <div className={styles.title}>
                { title }{range && ` | X : ${range && range.title}`}
            </div>
        </div>
    )
}

export default Chart;